import { ZendeskTagFilters } from "@app/components/data_source/ZendeskTagFilters";
import { useZendeskTicketTagFilters } from "@app/hooks/useZendeskTicketTagFilters";
import type { DataSourceType } from "@app/types/data_source";
import type { WorkspaceType } from "@app/types/user";
import { useTranslation } from "react-i18next";

export function ZendeskTicketTagFilters({
  owner,
  readOnly,
  isAdmin,
  dataSource,
}: {
  owner: WorkspaceType;
  readOnly: boolean;
  isAdmin: boolean;
  dataSource: DataSourceType;
}) {
  const { t } = useTranslation();
  const { ticketTagFilters, addTicketTag, removeTicketTag, loading } =
    useZendeskTicketTagFilters({ owner, dataSource });

  return (
    <ZendeskTagFilters
      readOnly={readOnly}
      isAdmin={isAdmin}
      title={t("spaces.zendeskTicketTagFiltersTitle", "Ticket Tag Filters")}
      description={t(
        "spaces.zendeskTicketTagFiltersDescription",
        "Include or exclude tickets from the sync based on their tags. These filters only apply to future syncing and will not retroactively remove already-synced tickets."
      )}
      tagFilters={ticketTagFilters}
      addTag={addTicketTag}
      removeTag={removeTicketTag}
      loading={loading}
      placeholder={t("spaces.enterTagNamePlaceholder", "Enter tag name")}
    />
  );
}
